import { z } from 'zod';
/** Nome lega: visibile ovunque, tenuto ragionevole. */
export const leagueNameSchema = z
    .string()
    .trim()
    .min(3, 'Il nome della lega deve avere almeno 3 caratteri')
    .max(60, 'Il nome della lega non può superare 60 caratteri');
export const createLeagueSchema = z.object({
    name: leagueNameSchema,
    seasonId: z.string().min(1, 'Seleziona un campionato'),
    maxParticipants: z
        .number()
        .int()
        .min(2, 'Servono almeno 2 partecipanti')
        .max(100, 'Massimo 100 partecipanti')
        .default(20),
    timezone: z.string().default('Europe/Rome'),
    startDate: z.string().datetime().optional(),
    endDate: z.string().datetime().optional(),
    /** Versione ruleset di partenza (default: Panda Classic v1 di sistema). */
    rulesetVersionId: z.string().optional(),
    /** Attiva il giocatore bot (es. Cita) con pronostici casuali. */
    botPlayer: z
        .object({
        enabled: z.boolean().default(false),
        name: z.string().trim().min(1).max(50).default('Cita'),
    })
        .optional(),
});
export const updateLeagueSchema = z.object({
    name: leagueNameSchema.optional(),
    maxParticipants: z.number().int().min(2).max(100).optional(),
    timezone: z.string().optional(),
    startDate: z.string().datetime().nullable().optional(),
    endDate: z.string().datetime().nullable().optional(),
    status: z.enum(['DRAFT', 'ACTIVE', 'ARCHIVED']).optional(),
});
export const createInviteSchema = z.object({
    /** Email per invito nominale (opzionale: senza, è un link/codice aperto). */
    email: z.string().trim().toLowerCase().email('Email non valida').optional(),
    maxUses: z.number().int().min(1).max(1000).default(1),
    expiresInDays: z.number().int().min(1).max(365).optional(),
    requiresApproval: z.boolean().default(false),
});
export const updateMemberSchema = z.object({
    role: z.enum(['ADMIN', 'PLAYER']).optional(),
    status: z.enum(['ACTIVE', 'SUSPENDED']).optional(),
    /** Nuovo nome del giocatore bot (accettato solo su membri bot). */
    botName: z.string().trim().min(1, 'Il nome non può essere vuoto').max(50).optional(),
});
/**
 * Automazioni di lega (League.settings.automation).
 * Tutto opzionale: con le opzioni spente l'admin gestisce ogni passo a mano.
 */
export const automationSettingsSchema = z.object({
    /**
     * Chiusura automatica dei pronostici: la deadline viene calcolata da sola
     * come "N minuti prima del calcio d'inizio della prima partita" e la
     * giornata si apre e si chiude senza indicare data e ora.
     */
    autoDeadline: z.boolean().default(true),
    autoDeadlineMinutesBefore: z.number().int().min(5).max(1440).default(10),
    /**
     * Calcolo automatico: quando l'ultima partita della giornata è finita
     * (risultati importati), punteggi e classifica vengono calcolati e
     * pubblicati da soli. L'admin può sempre intervenire dopo
     * (ricalcolo, correzioni manuali con motivo).
     */
    autoScoring: z.boolean().default(true),
    /** Mette in cantiere da sola la prossima giornata del campionato quando
     *  tutte quelle della lega sono pubblicate (richiede autoDeadline). */
    autoCreate: z.boolean().default(true),
});
export const DEFAULT_AUTOMATION = automationSettingsSchema.parse({});
//# sourceMappingURL=league.js.map